import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CellEditorComponent } from './cell-editor.component';
import { CellEditorDirective } from './cell-editor.directive';

export * from './cell-editor.component';
export * from './cell-editor.directive';
export * from './cell-editor.service';

@NgModule({
    declarations: [
        CellEditorComponent,
        CellEditorDirective,
    ],
    exports: [
        CellEditorComponent,
        CellEditorDirective,
    ],
    imports: [
        CommonModule,
    ],
})
export class CellEditorModule {}
